module.exports = __webpack_public_path__ + "static/media/BGD.a9216075.svg";